/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCostbasisV1RealizationState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_COSTBASIS_V1_REALIZATION_STATE_ENTITY_NAME = 'ixc.costbasis.v1.Realization';
export const ixcCostbasisV1RealizationStateEntity = new schema.Entity<IxcCostbasisV1RealizationState>(IXC_COSTBASIS_V1_REALIZATION_STATE_ENTITY_NAME, {}, { idAttribute: 'realizationId' });

